<div id="shared-input" class="input-box">
  <app-icon
    id="shared-icon-search"
    [name]="prefixIcon"
    color="grey"
    class="search-icon"
    size="1em"
  ></app-icon>
  <input
    matInput
    [type]="inputType"
    id="input-field"
    [placeholder]="placeholder"
    [maxlength]="maxLength"
    [formControl]="inputText"
    [ngClass]="getInputClass()"
    (change)="onChangeInput($event)"
    (keyup.enter)="onKeyEnter($event)"
    (keypress)="onKeyPress($event)"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
  />
  <app-icon
    *ngIf="inputText.value"
    name="cancel"
    class="cancel-icon"
    id="cancel-icon"
    color="grey"
    size="1.2em"
    (iconClicked)="onCancel()"
  ></app-icon>
  <app-icon
    *ngIf="showErrorIcon()"
    name="error"
    class="cancel-icon error-icon"
    id="cancel-icon"
    size="1.2em"
    (iconClicked)="onCancel()"
  ></app-icon>
</div>

<mat-error
  id="shared-icon-error"
  *ngIf="this.isRequired && inputText.value === '' && inputText.touched"
>
  <app-text id="shared-icon-error-text" [textStyleType]="'caption'">{{
    'input.validator' | translate
  }}</app-text>
</mat-error>

<mat-error id="shared-icon-error-maxlength" *ngIf="inputText.hasError('maxlength')">
  <app-text id="shared-icon-error-maxlength-text" [textStyleType]="'caption'"
    >{{ 'input.maxlength' | translate }} {{ maxLength }}.</app-text
  >
</mat-error>
